import WebGalleryAlbumNavigationlessHeader from './WebGalleryAlbumNavigationlessHeader';

export default WebGalleryAlbumNavigationlessHeader;
